import { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { jwtDecode } from "jwt-decode"; // gunakan named export untuk jwt-decode v4+

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

// Ambil user id unik dari token (pakai "sub")
function getUserIdFromToken() {
  const token = sessionStorage.getItem("token");
  if (!token) return "guest";
  try {
    const decoded = jwtDecode(token);
    return decoded?.sub || "guest";
  } catch (e) {
    console.error("Invalid token:", e);
    return "guest";
  }
}

export const CartProvider = ({ children }) => {
  const userId = getUserIdFromToken();
  const storageKey = `cart_${userId}`;

  // Load cart awal sesuai user
  const [cart, setCart] = useState(() => {
    const saved = localStorage.getItem(storageKey);
    return saved ? JSON.parse(saved) : [];
  });

  // Jika user berganti (token berubah), muat keranjang untuk user baru
  useEffect(() => {
    const saved = localStorage.getItem(storageKey);
    setCart(saved ? JSON.parse(saved) : []);
  }, [storageKey]);

  // Simpan perubahan cart ke localStorage
  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(cart));
  }, [cart, storageKey]);

  // Tambah produk (default +1)
  const addToCart = (product, qty = 1) => {
    setCart((prev) => {
      const existing = prev.find((i) => i.id === product.id);
      if (existing) {
        return prev.map((i) => (i.id === product.id ? { ...i, qty: i.qty + qty } : i));
      }
      return [...prev, { ...product, qty }];
    });
  };

  // Set qty ke nilai tertentu (hapus jika <= 0)
  const updateQty = (id, newQty) => {
    setCart((prev) => {
      if (newQty <= 0) return prev.filter((i) => i.id !== id);
      return prev.map((i) => (i.id === id ? { ...i, qty: newQty } : i));
    });
  };

  // Kurangi qty 1 (hapus jika jadi 0)
  const decreaseQty = (id) => {
    setCart((prev) =>
      prev.map((i) => (i.id === id ? { ...i, qty: i.qty - 1 } : i)).filter((i) => i.qty > 0)
    );
  };

  // Hapus 1 item
  const removeFromCart = (id) => {
    setCart((prev) => prev.filter((i) => i.id !== id));
  };

  // Kosongkan keranjang
  const clearCart = () => setCart([]);

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        updateQty,
        decreaseQty,
        removeFromCart,
        clearCart,
        userId,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

CartProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
